<template>
<el-dialog title="开通科目" :visible.sync="dialogVisible" width="80%" @close="handleClose" class="opened-subject-dialog" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-table :data="tableData" style="width: 100%" height="calc(100% - 52px)">
        <el-table-column label="序号" width="80px" align="center">
            <template slot-scope="scope">{{(page - 1) * pagesize + scope.$index + 1}}</template>
        </el-table-column>
        <el-table-column prop="examname" label="考试名称" min-width="200px" show-overflow-tooltip>
            <template slot-scope="scope">{{scope.row.examname}}</template>
        </el-table-column>
        <el-table-column prop="subjectname" label="科目名称" min-width="200px" show-overflow-tooltip>
            <template slot-scope="scope">{{scope.row.subjectname}}</template>
        </el-table-column>
        <el-table-column prop="statusname" label="当前状态" width="100px" align="center">
            <template slot-scope="scope">
                <div :class="['status' + scope.row.status]">{{scope.row.statusname}}</div>
            </template>
        </el-table-column>
        <el-table-column prop="userexpiredate" label="过期时间" width="110px" align="center"></el-table-column>
        <el-table-column prop="datetime" label="首次时间" width="150px" align="center"></el-table-column>
    </el-table>
    <el-pagination background layout="sizes, prev, pager, next" :total="total" :page-size="pagesize" :current-page="page" @size-change="handlePagesizeChange" @current-change="handlePageChange" :page-sizes="[10, 20, 50, 100]"></el-pagination>
</el-dialog>
</template>

<script>
import {getQuestionbankUserSubjectList} from 'api/questionApi'
export default {
    name: 'openedSubjectDialog',
    data() {
        return {
            dialogVisible: false,
            customerinnerid: '',
            examcode: '',
            tableData: [],
            total: 0,
            page: 1,
            pagesize: 10,
            contentLoading: false
        }
    },
    mounted() {
    },
    methods: {
        handleOpen(row) {
            this.dialogVisible = true
            this.customerinnerid = row.customerinnerid
            this.examcode = this.$route.query.examcode
            this.handleGetQuestionbankUserSubjectList()
        },
        handleClose() {
            this.dialogVisible = false
            this.customerinnerid = ''
            this.examcode = ''
            this.tableData = []
            this.total = 0
            this.page = 1
            this.pagesize = 10
        },
        handleGetQuestionbankUserSubjectList() {
            this.contentLoading = true
            getQuestionbankUserSubjectList({
                data: {
                    orderbyname: '',
                    orderbyorder: '',
                    page: this.page,
                    pagesize: this.pagesize,
                    condition: {
                        customerinnerid: this.customerinnerid,
                        examcode: this.examcode
                    }
                },
                success: data => {
                    this.tableData = data.data
                    this.total = data.pageableData.rowCount
                    this.contentLoading = false
                },
                error: data => {
                    this.contentLoading = false
                    this.$message.error(data.msg)
                }
            })
        },
        handlePagesizeChange(pagesize) {
            this.pagesize = pagesize
            this.page = 1
            this.handleGetQuestionbankUserSubjectList()
        },
        handlePageChange(page) {
            this.page = page
            this.handleGetQuestionbankUserSubjectList()
        }
    },
    filters: {},
    watch: {},
    computed: {},
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.opened-subject-dialog {
    .el-dialog {
        height: 80vh;
        margin: 10vh auto !important;
        .el-dialog__body {
            height: calc(80vh - 55px);
            box-sizing: border-box;
            .el-table {
                .status0 {
                    color: #606266;
                }
                .status1 {
                    color: #439FFE;
                }
            }
            .el-pagination {
                text-align: right;
                .el-pagination__sizes {
                    .el-select {
                        height: 28px;
                        .el-input {
                            height: 28px;
                            .el-input__inner {
                                height: 28px;
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>
